export default __webpack_public_path__ + "static/media/kartikey.png.webp";